import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const HouseOutlinedIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        strokeWidth="1.47692"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 1.54167C10.3148 0.652778 8.68514 0.652778 7.49995 1.54167L1.77281 5.83702C0.855043 6.52535 0.355723 7.63725 0.450994 8.7805L0.978465 15.1102C1.12243 16.8378 2.56666 18.1667 4.30028 18.1667H14.6996C16.4332 18.1667 17.8775 16.8378 18.0214 15.1102L18.5489 8.7805C18.6442 7.63725 18.1449 6.52535 17.2271 5.83702L11.5 1.54167ZM8.49995 2.875C9.09255 2.43056 9.90736 2.43056 10.5 2.875L16.2271 7.17035C16.686 7.51452 16.9356 8.07047 16.888 8.6421L16.3605 14.9717C16.2885 15.8356 15.5664 16.5 14.6996 16.5H12.0723L12.2407 14.4787C12.3744 12.8752 11.109 11.5 9.49995 11.5C7.89093 11.5 6.62555 12.8752 6.75918 14.4787L6.92762 16.5H4.30028C3.43347 16.5 2.71136 15.8356 2.63937 14.9717L2.1119 8.6421C2.06427 8.07047 2.31393 7.51452 2.77281 7.17035L8.49995 2.875ZM10.5798 14.3403L10.3998 16.5H8.60006L8.42009 14.3403C8.36744 13.7085 8.866 13.1667 9.49995 13.1667C10.1339 13.1667 10.6325 13.7085 10.5798 14.3403Z"

      />
    </SvgIcon>
  )
}
